import { render } from "./UpdateSubscription.vue?vue&type=template&id=36d87e82"
import script from "./UpdateSubscription.vue?vue&type=script&lang=js"
export * from "./UpdateSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__